<template>
  <RevList :has-external-borders="false">
    <RevAccordionItem>
      <template #prefix>
        <IconCheckInCircle />
      </template>
      <template #title>
        {{ i18n(translations.unlimitedTalkAndTextTitle) }}
      </template>
      <template #body>
        <p class="body-1">
          {{ i18n(translations.unlimitedTalkAndTextDescription) }}
        </p>
      </template>
    </RevAccordionItem>

    <RevAccordionItem>
      <template #prefix>
        <IconCheckInCircle />
      </template>
      <template #title>
        {{ i18n(translations.premiumCoverageTitle) }}
      </template>
      <template #body>
        <p class="body-1 whitespace-pre-line">
          {{ i18n(translations.populationCoverage) }}
        </p>
      </template>
    </RevAccordionItem>

    <RevAccordionItem>
      <template #prefix>
        <IconCheckInCircle />
      </template>
      <template #title>
        {{ i18n(translations.spamAndRobocallsBlockedTitle) }}
      </template>
      <template #body>
        <p class="body-1">
          {{ i18n(translations.spamAndRobocallsBlockedContent) }}
        </p>
      </template>
    </RevAccordionItem>
  </RevList>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevAccordionItem } from '@ds/components/AccordionItem'
import { RevList } from '@ds/components/List'
import { IconCheckInCircle } from '@ds/icons/IconCheckInCircle'

import translations from './VerizonNetworkList.translations'

const i18n = useI18n()
</script>
